import React from "react";
import UserReferenceResponse from "../../../../api/models/UserReferenceResponse";
import {
  UsersSearchMultipleAutocomplete, //
} from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";

interface ApproversInputProps {
  values: UserReferenceResponse[];
}

const ApproversInput: React.FC<ApproversInputProps> = ({ values }) => {
  return (
    <UsersSearchMultipleAutocomplete
      disabled
      inputLabel="Approved by"
      map={(data): { key: string; label: string } => ({
        key: data.userEmail || "",
        label: data.userName || "",
      })}
      onChange={() => {}}
      optionFetch={() => {
        return Promise.resolve({
          data: [] as UserReferenceResponse[],
          totalPages: 0,
        });
      }}
      value={values}
    />
  );
};

export default ApproversInput;
